import { FC } from 'react'
import { cn, Skeleton } from '@wellesley/ui'

export type TSkeletonCard = {
  className?: string
  showMedia?: boolean
  showAvatar?: boolean
  showFooter?: boolean
  showPollsOptions?: boolean
}

const PollsOptions: FC = () =>
  Array.from(Array(4).keys()).map((_, index: number) => (
    <div key={index} className="gap-xxs mt-s flex flex-col">
      <Skeleton className="h-l w-full" />
    </div>
  ))

const SkeletonText: FC = () => (
  <div className="gap-xxs flex flex-col">
    {Array.from(Array(4).keys()).map((_, index: number) => (
      <Skeleton className="h-xxxs w-full rounded-full" key={index} />
    ))}
    <Skeleton className="h-xxxs w-[50%] rounded-full" />
  </div>
)

const FooterLine: FC = () => (
  <div className="flex justify-between">
    <div className="gap-xl flex">
      <Skeleton className="size-xxs rounded-full" />
      <Skeleton className="size-xxs rounded-full" />
      <Skeleton className="size-xxs rounded-full" />
    </div>
    <div className="gap-xl flex">
      <Skeleton className="size-xxs rounded-full" />
      <Skeleton className="size-xxs rounded-full" />
    </div>
  </div>
)

const SkeletonMenu: FC = () => (
  <div className="flex gap-[6px]">
    <Skeleton className="size-xxxs rounded-full" />
    <Skeleton className="size-xxxs rounded-full" />
    <Skeleton className="h-xxxs w-[60px] rounded-full" />
    <Skeleton className="size-xxxs rounded-full" />
    <Skeleton className="size-xxxs rounded-full" />
  </div>
)

const PostCardSkeleton: FC<TSkeletonCard> = ({
  className,
  showAvatar,
  showFooter,
  showPollsOptions,
}) => (
  <div
    data-testid="post-card-skeleton"
    className={cn('py-s space-y-xs flex flex-col', className)}
  >
    <div className="gap-xxs flex items-center">
      {showAvatar && <Skeleton className="size-m rounded-full" />}
      <div className="flex flex-col gap-[6px]">
        <Skeleton className="h-xxxs w-[160px] rounded-full" />
        <Skeleton className="h-3 w-[96px] rounded-full" />
      </div>
      <div className="mb-auto ml-auto">
        <SkeletonMenu />
      </div>
    </div>
    <div className="my-xs">
      <SkeletonText />
    </div>
    {showPollsOptions && <PollsOptions />}
    {showFooter && <FooterLine />}
  </div>
)

export default PostCardSkeleton
